import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import {
    selectSubject,
    selectTicketIsFetched,
} from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { getTicketIdUiFriendly } from 'flow/utils/ticket-utils';

type Props = {
    ticketKey: TicketKey;
    muted?: boolean;
};

const SectionSubject = ({ ticketKey, muted }: Props) => {
    const { i18next } = useAppContext();

    const subject = useAppSelector((state) => selectSubject(state, ticketKey));
    const ticketIsFetched = useAppSelector((state) =>
        selectTicketIsFetched(state, ticketKey),
    );

    if (!ticketIsFetched) {
        return <div className="h-6" />;
    }

    const hasSubject = !!subject;
    const ticketId = getTicketIdUiFriendly(ticketKey);

    return (
        <div className="flex h-6 items-center text-sm">
            <span className="line-clamp-1 break-all">
                {ticketId ? (
                    <span className={muted ? 'text-gray-500' : 'text-gray-800'}>
                        {ticketId}
                        {' • '}
                    </span>
                ) : null}
                <span
                    className={
                        muted
                            ? 'text-gray-500'
                            : hasSubject
                              ? 'text-gray-800'
                              : 'text-gray-400'
                    }
                >
                    {hasSubject ? subject : i18next.t('ticket.subject.none')}
                </span>
            </span>
        </div>
    );
};

export default React.memo(SectionSubject);
